export default __webpack_public_path__ + "static/media/gabriel.d1303878.png";